import getJsonLdScriptId from "@insite/client-framework/Common/Utilities/getJsonLdScriptId";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import setPageMetadata, { Metadata } from "@insite/client-framework/Common/Utilities/setPageMetadata";
import { trackPageChange } from "@insite/client-framework/Common/Utilities/tracking";
import { HasDeferredApiContext, withCallDeferredApi } from "@insite/client-framework/Components/DeferredApiContext";
import { ParentProductIdContext } from "@insite/client-framework/Components/ParentProductContext";
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import { getUrl } from "@insite/client-framework/ServerSideRendering";
import { getContentByVersionPath } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getSelectedProductPath,
    getSession,
    getSettingsCollection,
    getShouldPreventCatalogLoop,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    getComputedVariantProduct,
    getProductState,
    getProductStateByPath,
    getVariantChildrenDataView,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import changeQtyOrdered from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/ChangeQtyOrdered";
import changeUnitOfMeasure from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/ChangeUnitOfMeasure";
import displayProduct from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import generateStructuredPageData from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/GenerateStructuredPageData";
import loadProductPricingAndInventory from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/LoadProductPricingAndInventory";
import resetSelections from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/ResetSelections";
import setMetadataSetForId from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/SetMetadataSetForId";
import { HideFooter, HideHeader } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CurrentCategory from "@insite/content-library/Components/CurrentCategory";
import Modals from "@insite/content-library/Components/Modals";
import Page from "@insite/mobius/Page";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { createGlobalStyle, css, ThemeProps, withTheme } from "styled-components";

const GlobalStyleNew = createGlobalStyle`
  /* Loader CSS*/
    .my-animation {
        margin-top: 30px;
    }

    .timeline-wrapper,
    .timeline-wrapper-tabs {
        width: 100%;
        display: block;
    }

    .timeline-item,
    .timeline-item-tabs {
        background: #fff;
        border: 1px solid;
        border-color: #e5e6e9 #dfe0e4 #d0d1d5;
        border-radius: 3px;
        padding: 12px;	
        margin: 0 auto;
        border-bottom: none;
    }
    .timeline-item-tabs{
        border-bottom: 1px solid;
        border-color: #e5e6e9 #dfe0e4 #d0d1d5;
        border-top: none;

        margin-top: -152px;
    }

    .description{
        position: relative;
        margin-top: 100px;
    }


    @keyframes placeHolderShimmer{
        0%{
            background-position: -468px 0
        }
        100%{
            background-position: 468px 0
        }
    }

    .animated-background,
    .animated-background-tabs{
        animation-duration: 1s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: placeHolderShimmer;
        animation-timing-function: linear;
        background: #f6f7f8;
        background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
        background-size: 800px 104px;
        height: 620px;
        position: relative;
    }
    .animated-background-tabs{
        height: 600px;
    }


    .background-masker,
    .background-masker-tabs {
        background: #fff;
        position: absolute;
    }

    /* Every thing below this is just positioning */

    .background-masker.top-vertical-0 {
        top: 0;
        left: 0;
        right: 0;
        height: 630px;
        width: 15px;
    }

    .background-masker.top-vertical-1 {
        top: 0;
        left: 35%;
        right: 0;
        height: 630px;
        width: 30px;
    }

    .background-masker.top-vertical-2 {
        top: 0;
        left: 70%;
        right: 0;
        height: 630px;
        width: 30px;
    }

    .background-masker.main-image-seperator {
        bottom: 270px;
        left: 0;
        height: 20px;
        width: 35%;
    }

    .background-masker.main-image-seperator-2 {
        bottom: 55px;
        left: 0;
        height: 120px;
        width: 35%;
    }

    .background-masker.center-seperator-1 {
        top: 0;
        left: 35%;
        height: 10px;
        width: 35%;
    }

    .background-masker.center-seperator-2 {
        top: 35px;
        left: 35%;
        height: 25px;
        width: 35%;
    }

    .background-masker.center-seperator-3 {
        top: 120px;
        left: 35%;
        height: 25px;
        width: 35%;
    }

    .background-masker.center-seperator-4 {
        top: 170px;
        left: 35%;
        height: 550px;
        width: 35%;
    }

    .background-masker.right-seperator-1{
        top: 0;
        left: 72%;
        height: 10px;
        width: 28%;
    }
    .background-masker.right-seperator-2{
        top: 35px;
        left: 70%;
        height: 25px;
        width: 30%;
    }
    .background-masker.right-seperator-3{
        top: 85px;
        left: 72%;
        height: 25px;
        width: 28%;
    }
    .background-masker.right-seperator-4{
        top: 135px;
        left: 72%;
        height: 25px;
        width: 28%;
    }
    .background-masker.right-seperator-5{
        top: 185px;
        left: 72%;
        height: 25px;
        width: 28%;
    }
    .background-masker.right-seperator-6{
        top: 235px;
        left: 72%;
        height: 25px;
        width: 28%;
    }
    .background-masker.right-seperator-7{
        top: 285px;
        left: 72%;
        height: 25px;
        width: 28%;
    }

    .background-masker.right-seperator-8{
        top: 370px;
        left: 70%;
        height: 355px;
        width: 30%;
    }

    .background-masker-tabs.bottom-seperator-1{
        top: 0;
        left: 0;
        height: 100px;
        width: 100%;
    }
    .background-masker-tabs.bottom-seperator-2{
        top: 150px;
        left: 0;
        height: 30px;
        width: 100%;
    }
    .background-masker-tabs.bottom-seperator-3{
        top: 270px;
        left: 0;
        height: 90px;
        width: 100%;
    }
    .background-masker-tabs.bottom-seperator-4{
        top: 410px;
        left: 0;
        height: 30px;
        width: 100%;
    }
    .background-masker-tabs.bottom-seperator-5{
        top: 500px;
        left: 0;
        height: 40px;
        width: 100%;
    }
    .background-masker-tabs.bottom-seperator-6{
        top: 590px;
        left: 0;
        height: 30px;
        width: 100%;
    }
    .background-masker-tabs.bottom-seperator-7{
        top: 515px;
        left: 0;
        height: 200px;
        width: 100%;
    }


    .background-masker.thumb-left-1 {
        bottom: 175px;
        left: 0;
        height: 96px;
        width: 50px;
    }

    .background-masker.thumb-left-2 {
        bottom: 175px;
        left: 11%;
        height: 96px;
        width: 50px;
    }

    .background-masker.thumb-left-3 {
        bottom: 175px;
        left: 22%;
        height: 96px;
        width: 50px;
    }

    .background-masker.thumb-left-4 {
        bottom: 175px;
        left: 33%;
        height: 96px;
        width: 50px;
    }

    .background-masker.center-top-1 {
        top: 10px;
        left: 35%;
        height: 25px;
        width: 10%;
    }

    .background-masker.center-top-2 {
        top: 10px;
        left: 54%;
        height: 25px;
        width: 3%;
    }

    .background-masker.center-top-3 {
        top: 10px;
        left: 61%;
        height: 25px;
        width: 2%;
    }

    .background-masker.center-top-4 {
        top: 10px;
        left: 67%;
        height: 25px;
        width: 4%;
    }

    .background-masker.center-top-5 {
        top: 60px;
        left: 45%;
        height: 25px;
        width: 25%;
    }

    .background-masker.center-top-6 {
        top: 145px;
        left: 48%;
        height: 30px;
        width: 5%;
    }

    .background-masker.center-top-7 {
        top: 145px;
        left: 64%;
        height: 30px;
        width: 6%;
    }

    .background-masker.right-top-1 {
        top: 10px;
        left: 68%;
        height: 25px;
        width: 7%;
    }
    .background-masker.right-top-2 {
        top: 10px;
        left: 82%;
        height: 25px;
        width: 18%;
    }
    .background-masker.right-top-3 {
        top: 60px;
        left: 72%;
        height: 25px;
        width: 3%;
    }
    .background-masker.right-top-4 {
        top: 60px;
        left: 79%;
        height: 25px;
        width: 21%;
    }
    .background-masker.right-top-5 {
        top: 110px;
        left: 72%;
        height: 25px;
        width: 3%;
    }
    .background-masker.right-top-6 {
        top: 110px;
        left: 83%;
        height: 25px;
        width: 17%;
    }
    .background-masker.right-top-7 {
        top: 135px;
        left: 72%;
        height: 25px;
        width: 3%;
    }
    .background-masker.right-top-8 {
        top: 135px;
        left: 80%;
        height: 25px;
        width: 20%;
    }
    .background-masker.right-top-9 {
        top: 160px;
        left: 72%;
        height: 25px;
        width: 3%;
    }
    .background-masker.right-top-10 {
        top: 160px;
        left: 85%;
        height: 25px;
        width: 15%;
    }
    .background-masker.right-top-11 {
        top: 210px;
        left: 72%;
        height: 25px;
        width: 3%;
    }
    .background-masker.right-top-12 {
        top: 210px;
        left: 99%;
        height: 25px;
        width: 1%;
    }
    .background-masker.right-top-13 {
        top: 260px;
        left: 72%;
        height: 25px;
        width: 3%;
    }
    .background-masker.right-top-14 {
        top: 260px;
        left: 99%;
        height: 25px;
        width: 1%;
    }
    .background-masker.right-top-15 {
        top: 310px;
        left: 72%;
        height: 60px;
        width: 3%;
    }
    .background-masker.right-top-16 {
        top: 310px;
        left: 99%;
        height: 60px;
        width: 1%;
    }

    .background-masker-tabs.bottom-top-1 {
        top: 100px;
        left: 0%;
        height: 50px;
        width: 2%;
    }
    .background-masker-tabs.bottom-top-2 {
        top: 100px;
        left: 17%;
        height: 50px;
        width: 54%;
    }
    .background-masker-tabs.bottom-top-3 {
        top: 100px;
        left: 70%;
        height: 50px;
        width: 30%;
    }
    .background-masker-tabs.bottom-top-4 {
        top: 180px;
        left: 0%;
        height: 90px;
        width: 2%;
    }
    .background-masker-tabs.bottom-top-5 {
        top: 180px;
        left: 68%;
        height: 90px;
        width: 32%;
    }
    .background-masker-tabs.bottom-top-6 {
        top: 360px;
        left: 0%;
        height: 50px;
        width: 2%;
    }
    .background-masker-tabs.bottom-top-7 {
        top: 360px;
        left: 20%;
        height: 50px;
        width: 54%;
    }
    .background-masker-tabs.bottom-top-8 {
        top: 360px;
        left: 70%;
        height: 50px;
        width: 30%;
    }
    .background-masker-tabs.bottom-top-9 {
        top: 440px;
        left: 0%;
        height: 60px;
        width: 2%;
    }
    .background-masker-tabs.bottom-top-10 {
        top: 440px;
        left: 15%;
        height: 60px;
        width: 85%;
    }
    .background-masker-tabs.bottom-top-11 {
        top: 540px;
        left: 0%;
        height: 50px;
        width: 2%;
    }
    .background-masker-tabs.bottom-top-12 {
        top: 540px;
        left: 15%;
        height: 50px;
        width: 53%;
    }
    .background-masker-tabs.bottom-top-13 {
        top: 540px;
        left: 70%;
        height: 50px;
        width: 30%;
    }
    .background-masker-tabs.bottom-top-14 {
        top: 620px;
        left: 0%;
        height: 40px;
        width: 2%;
    }
    .background-masker-tabs.bottom-top-15 {
        top: 620px;
        left: 25%;
        height: 40px;
        width: 75%;
    }

    .background-masker.header-bottom {
        top: 0;
        left: 40px;
        right: 0;
        height: 10px;
    }

    .background-masker.subheader-bottom {
        top: 0;
        left: 40px;
        right: 0;
        height: 20px;
    }

    .background-masker.header-left,
    .background-masker.subheader-left,
    .background-masker.header-right,
    .background-masker.subheader-right {
        top: 10px;
        left: 40px;
        height: 8px;
        width: 10px;
    }

    .background-masker.header-bottom {
        top: 18px;
        height: 6px;
    }

    .background-masker.subheader-left,
    .background-masker.subheader-right {
        top: 24px;
        height: 6px;
    }

    .background-masker.header-right,
    .background-masker.subheader-right {
        width: auto;
        left: 300px;
        right: 0;
    }

    .background-masker.subheader-right {
        left: 230px;
    }

    .background-masker.subheader-bottom {
        top: 30px;
        height: 10px;
    }

    .background-masker.content-top,
    .background-masker.content-second-line,
    .background-masker.content-third-line,
    .background-masker.content-second-end,
    .background-masker.content-third-end,
    .background-masker.content-first-end {
        top: 40px;
        left: 0;
        right: 0;
        height: 6px;
    }

    .background-masker.content-top {
        height:20px;
    }

    .background-masker.content-first-end,
    .background-masker.content-second-end,
    .background-masker.content-third-end{
        width: auto;
        left: 380px;
        right: 0;
        top: 60px;
        height: 8px;
    }

    .background-masker.content-second-line  {
        top: 68px;
    }

    .background-masker.content-second-end {
        left: 420px;
        top: 74px;
    }

    .background-masker.content-third-line {
        top: 82px;
    }

    .background-masker.content-third-end {
        left: 300px;
        top: 88px;
    }

    @media screen and (min-width: 768px) and (max-width: 1024px) {
        .background-masker.thumb-left-1 {
            bottom: 175px;
            left: 0;
            height: 100px;
            width: 15px;
        }
    
        .background-masker.thumb-left-2 {
            bottom: 175px;
            left: 11%;
            height: 100px;
            width: 15px;
        }
    
        .background-masker.thumb-left-3 {
            bottom: 175px;
            left: 22%;
            height: 100px;
            width: 15px;
        }
    
        .background-masker.thumb-left-4 {
            bottom: 175px;
            left: 33%;
            height: 100px;
            width: 20px;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 990px) {
        .animated-background,
        .animated-background-tabs {
            height: 560px;
        }

        .background-masker.main-image-seperator-2 {
            bottom: 74px;
            left: 0;
            height: 120px;
            width: 35%;
        }
        .background-masker.thumb-left-1 {
            bottom: 194px;
            left: 3px;
            height: 78px;
            width: 22px;
        }
        .background-masker.thumb-left-2 {
            bottom: 175px;
            left: 12%;
            height: 100px;
            width: 20px;
        }
        .background-masker.thumb-left-3 {
            bottom: 175px;
            left: 22.5%;
            height: 100px;
            width: 18px;
        }
        .background-masker.thumb-left-4 {
            bottom: 175px;
            left: 33.5%;
            height: 100px;
            width: 18px;
        }
    }

    @media only screen and (min-width: 768px){
        .desktop-d-none {
            display: none;
        }
    }

    @media only screen and (max-width: 767px) {
        .mob-d-none {
            display:none;
        }
        .animated-background {
            height: 150vh;
        }
        .background-masker.center-seperator-1 {
            top: 0;
            left: 0%;
            height: 10px;
            width: 100%;
        }
        .background-masker.center-seperator-2 {
            top: 40px;
            left: 0%;
            height: 25px;
            width: 100%;
        }
        .background-masker.center-seperator-3 {
            top: 150px;
            left: 0;
            height: 25px;
            width: 100%;
        }
        .background-masker.center-seperator-4 {
            top: 220px;
            left: 0;
            height: 25px;
            width: 100%;
        }
        .background-masker.main-image-seperator {
            top: 500px;
            left: 0;
            height: 25px;
            width: 100%;
        }
        .background-masker.main-image-seperator-2 {
            top: 590px;
            left: 0;
            height: 25px;
            width: 100%;
        }
        .background-masker.right-seperator-1{
            top: 640px;
            left: 0;
            height: 25px;
            width: 100%;
        }
        .background-masker.right-seperator-2{
            top: 690px;
            left: 0;
            height: 25px;
            width: 100%;
        }
        .background-masker.right-seperator-3{
            top: 690px;
            left: 0;
            height: 25px;
            width: 100%;
        }
        .background-masker.right-seperator-4{
            top: 820px;
            left: 0;
            height: 25px;
            width: 100%;
        }
        .background-masker.right-seperator-5{
            top: 880px;
            left: 0;
            height: 25px;
            width: 100%;
        }
        .background-masker.thumb-left-1 {
            top: 520px;
            left: 0;
            height: 70px;
            width: 17%;
        }
        .background-masker.thumb-left-2 {
            top: 520px;
            left: 37%;
            height: 70px;
            width: 3%;
        }
        .background-masker.thumb-left-3 {
            top: 520px;
            left: 60%;
            height: 70px;
            width: 3%;
        }
        .background-masker.thumb-left-4 {
            top: 520px;
            left: 83%;
            height: 70px;
            width: 18%;
        }
        .background-masker.center-top-1 {
            top: 10px;
            left: 0;
            height: 30px;
            width: 30%;
        }
        .background-masker.center-top-2 {
            top: 10px;
            left: 50%;
            height: 30px;
            width: 14%;
        }
        .background-masker.center-top-3 {
            top: 10px;
            left: 73%;
            height: 30px;
            width: 5%;
        }
        .background-masker.center-top-4 {
            top: 10px;
            left: 86%;
            height: 30px;
            width: 20%;
        }
        .background-masker.center-top-5 {
            top: 65px;
            left: 20%;
            height: 25px;
            width: 80%;
        }
        .background-masker.center-top-6 {
            top: 173px;
            left: 45%;
            height: 50px;
            width: 55%;
        }
        .background-masker.right-top-1 {
            top: 615px;
            left: 15%;
            height: 25px;
            width: 85%;
        }
        .background-masker.right-top-2 {
            top: 665px;
            left: 18%;
            height: 25px;
            width: 82%;
        }
        .background-masker.right-top-3{
            top: 715px;
            left: 35%;
            height: 25px;
            width: 65%;
        }
        .background-masker.right-top-4{
            top: 740px;
            left: 15%;
            height: 25px;
            width: 85%;
        }
        .background-masker.right-top-5{
            top: 752px;
            left: 40%;
            height: 45px;
            width: 60%;
        }
        .background-masker.right-top-6{
            top: 797px;
            left: 25%;
            height: 23px;
            width: 75%;
        }
        .background-masker-tabs.bottom-seperator-3{
            top: 350px;
            left: 0;
            height: 70px;
            width: 100%;
        }
        .background-masker-tabs.bottom-seperator-4{
            top: 470px;
            left: 0;
            height: 30px;
            width: 100%;
        }
        .background-masker-tabs.bottom-seperator-5{
            top: 560px;
            left: 0;
            height: 40px;
            width: 100%;
        }
        .background-masker-tabs.bottom-seperator-6{
            top: 650px;
            left: 0;
            height: 30px;
            width: 100%;
        }
        .background-masker-tabs.bottom-seperator-7{
            top: 710px;
            left: 0;
            height: 30px;
            width: 100%;
        }
        .background-masker-tabs.bottom-top-1 {
            top: 100px;
            left: 0%;
            height: 50px;
            width: 0;
        }
        .background-masker-tabs.bottom-top-2 {
            top: 100px;
            left: 40%;
            height: 50px;
            width: 56%;
        }
        .background-masker-tabs.bottom-top-3 {
            top: 100px;
            left: 95%;
            height: 50px;
            width: 6%;
        }
        .background-masker-tabs.bottom-top-4 {
            top: 190px;
            left: 0;
            height: 160px;
            width: 0;
        }
        .background-masker-tabs.bottom-top-5 {
            top: 180px;
            left: 95%;
            height: 170px;
            width: 6%;
        }
        .background-masker-tabs.bottom-top-6 {
            top: 420px;
            left: 0;
            height: 50px;
            width: 0;
        }
        .background-masker-tabs.bottom-top-7 {
            top: 420px;
            left: 53%;
            height:50px;
            width: 43%;
        }
        .background-masker-tabs.bottom-top-8 {
            top: 420px;
            left: 95%;
            height:50px;
            width: 6%;
        }
        .background-masker-tabs.bottom-top-9 {
            top: 500px;
            left: 0;
            height:60px;
            width: 0;
        }
        .background-masker-tabs.bottom-top-10 {
            top: 500px;
            left: 95%;
            height:60px;
            width: 6%;
        }
        .background-masker-tabs.bottom-top-11 {
            top: 600px;
            left: 0;
            height:50px;
            width: 5%;
        }
        .background-masker-tabs.bottom-top-12 {
            top: 600px;
            left: 45%;
            height:50px;
            width: 43%;
        }
        .background-masker-tabs.bottom-top-13 {
            top: 600px;
            left: 95%;
            height:50px;
            width: 5%;
        }
        .background-masker-tabs.bottom-top-14 {
            top: 680px;
            left: 0;
            height:50px;
            width: 5%;
        }
        .background-masker-tabs.bottom-top-15 {
            top: 680px;
            left: 95%;
            height:50px;
            width: 5%;
        }
        .timeline-item, 
        .timeline-item-tabs {
            border: none;
            padding: 12px 13px 12px 15px;
        }
    }
    /*End of Loader CSS*/
`;

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    let productPath =
        getSelectedProductPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);

    let queryString =
        location.search === "" && state.pages.productList.filterQuery
            ? state.pages.productList.filterQuery
            : location.search;
    if (location.pathname.toLowerCase().startsWith("/content/page/") && productPath.indexOf("?") > -1) {
        queryString = productPath ? productPath.substring(productPath.indexOf("?")) : "";
        productPath = productPath.substring(0, productPath.indexOf("?"));
    }

    const productState = getProductStateByPath(state, productPath);
    const catalogPageState = getCatalogPageStateByPath(state, productPath);
    const variantProductState = getProductState(state, state.pages.productDetails.selectedProductId);
    const computedVariantProduct = getComputedVariantProduct(productState, variantProductState);
    const variantChildren = getVariantChildrenDataView(state, productState.id);
    const settingsCollection = getSettingsCollection(state);
    return {
        productState: computedVariantProduct,
        variantProductState,
        catalogPageState,
        parentProductState: productState,
        productInfo:
            computedVariantProduct.value && state.pages.productDetails.productInfosById
                ? state.pages.productDetails.productInfosById[computedVariantProduct.value.id]
                : undefined,
        productPath,
        queryString,
        lastProductPath: state.pages.productDetails.lastProductPath,
        lastStyledOption: state.pages.productDetails.lastStyledOption,
        websiteName: state.context.website.name,
        page: getCurrentPage(state),
        location,
        websiteSettings: settingsCollection.websiteSettings,
        searchPath: settingsCollection.searchSettings.searchPath,
        selectedProductId: state.pages.productDetails.selectedProductId,
        isProductLoading: state.pages.productDetails.isProductLoading,
        metadataSetForId: state.pages.productDetails.metadataSetForId,
        structuredPageData: state.pages.productDetails.structuredPageData,
        structuredPageDataSetForId: state.pages.productDetails.structuredPageDataSetForId,
        session: getSession(state),
        productInfosById: state.pages.productDetails.productInfosById,
        variantChildren,
    };
};

const mapDispatchToProps = {
    displayProduct,
    changeQtyOrdered,
    changeUnitOfMeasure,
    resetSelections,
    generateStructuredPageData,
    setMetadataSetForId,
    loadProductPricingAndInventory,
};

type Props = ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    PageProps &
    HasDeferredApiContext;

class ProductDetailsPage extends React.Component<Props> {
    UNSAFE_componentWillMount() {
        if (!getShouldPreventCatalogLoop(this.props.deferredApiCalls)) {
            this.displayProductIfNeeded();
        }
        this.props.callDeferredApis({
            pricingHandler: () => {
                this.props.loadProductPricingAndInventory({
                    product: this.props.productState.value,
                    productInfosById: this.props.productInfosById,
                    variantChildren: this.props.variantChildren.value,
                    styledOption: this.getStyledOption(),
                });
            },
            inventoryHandler: () => {
                this.props.loadProductPricingAndInventory({
                    product: this.props.productState.value,
                    productInfosById: this.props.productInfosById,
                    variantChildren: this.props.variantChildren.value,
                    styledOption: this.getStyledOption(),
                });
            },
        });
        this.trySetMetadata();
    }

    componentDidUpdate(): void {
        this.displayProductIfNeeded();

        const { productState } = this.props;
        if (productState.value && productState.value.id !== this.props.metadataSetForId && this.trySetMetadata()) {
            trackPageChange();
        }
    }

    componentWillUnmount() {
        this.props.resetSelections();
    }

    trySetMetadata() {
        const {
            productState: { value: product },
            catalogPageState,
            websiteName,
            location,
            websiteSettings,
            page,
            structuredPageData,
            productInfo,
            session,
            metadataSetForId,
            structuredPageDataSetForId,
        } = this.props;

        if (!catalogPageState?.value || !product) {
            return false;
        }

        if (websiteSettings.enableProductStructuredData && product.id !== structuredPageDataSetForId) {
            this.props.generateStructuredPageData({
                product,
                productInfo,
                session,
                brandId: catalogPageState.value.brandId || product.brand?.id,
                categoryIdWithBrandId: catalogPageState.value.categoryIdWithBrandId,
                categoryId: catalogPageState.value.categoryId,
            });
            return false;
        }

        const {
            metaDescription,
            metaKeywords,
            openGraphImage,
            openGraphTitle,
            openGraphUrl,
            title,
            alternateLanguageUrls,
        } = catalogPageState.value;

        const pageMetaData: Metadata = {
            metaDescription,
            metaKeywords,
            openGraphImage,
            openGraphTitle,
            openGraphUrl,
            currentPath: location.pathname,
            canonicalPath: product.canonicalUrl,
            title: title || product.productTitle,
            websiteName,
            alternateLanguageUrls: alternateLanguageUrls ?? undefined,
            structuredPageData,
            jsonLdScriptId: getJsonLdScriptId(page.type),
        };

        if (catalogPageState.value.productId !== this.props.selectedProductId) {
            const variantContent = this.props.variantProductState.value?.content;
            if (variantContent) {
                const url: { protocol: string; host: string } = IS_SERVER_SIDE ? getUrl()! : window.location;
                const urlAddress = `${url.protocol.toLowerCase()}//${url.host.toLowerCase()}`;
                const imagePath =
                    variantContent.openGraphImage ||
                    product.smallImagePath ||
                    product.mediumImagePath ||
                    product.largeImagePath;

                const openGraphImage =
                    !imagePath || imagePath.indexOf("http://") > -1 || imagePath.indexOf("https://") > -1
                        ? imagePath
                        : urlAddress + imagePath.startsWith("/")
                        ? imagePath
                        : `/${imagePath}`;
                let openGraphUrl = variantContent.openGraphUrl || product.canonicalUrl;

                openGraphUrl =
                    !openGraphUrl || openGraphUrl.indexOf("http://") > -1 || openGraphUrl.indexOf("https://") > -1
                        ? openGraphUrl
                        : urlAddress + openGraphUrl.startsWith("/")
                        ? openGraphUrl
                        : `/${openGraphUrl}`;
                const pageTitle = variantContent.pageTitle || product.productTitle;

                pageMetaData.title = pageTitle;
                pageMetaData.metaKeywords =
                    variantContent.metaKeywords || `${product.productTitle} ${product.productNumber}`;
                pageMetaData.metaDescription = variantContent.metaDescription || product.productTitle;
                pageMetaData.openGraphTitle = variantContent.openGraphTitle || pageTitle;
                pageMetaData.openGraphImage = openGraphImage || "";
                pageMetaData.openGraphUrl = openGraphUrl || "";
            }
        }

        if (!openGraphImage && !pageMetaData.openGraphImage && product.images && product.images?.length > 0) {
            pageMetaData.openGraphImage = product.images[0].smallImagePath || product.images[0].mediumImagePath;
        }

        setPageMetadata(pageMetaData, websiteSettings);

        if (product.id !== metadataSetForId) {
            this.props.setMetadataSetForId({
                metadataSetForId: product.id,
            });
        }

        return true;
    }

    getStyledOption() {
        const { queryString } = this.props;
        const queryParams = parseQueryString<{ option?: string; criteria?: string }>(queryString.replace("?", ""));
        return (queryParams.option?.toString() || queryParams.criteria?.toString() || "").toLocaleLowerCase();
    }

    displayProductIfNeeded() {
        const { productPath, queryString, lastProductPath, lastStyledOption, isProductLoading, searchPath } =
            this.props;
        const styledOption = this.getStyledOption();
        if (
            (productPath.toLowerCase() === lastProductPath?.toLowerCase() &&
                styledOption === lastStyledOption?.toLowerCase()) ||
            productPath.toLowerCase() === `/${searchPath.toLowerCase()}`
        ) {
            return;
        }

        if (isProductLoading) {
            return;
        }

        this.props.displayProduct({ path: productPath, styledOption });
    }

    render() {
        if (!this.props.productState.value || !this.props.productInfo) {
            return (
                <>
                    <GlobalStyleNew />
                    <div className="my-animation">
                        <div className="timeline-wrapper mob-d-none">
                            <div className="timeline-item">
                                <div className="animated-background">
                                    <div className="background-masker top-vertical-0"></div>
                                    <div className="background-masker top-vertical-1"></div>
                                    <div className="background-masker top-vertical-2"></div>

                                    <div className="background-masker main-image-seperator"></div>
                                    <div className="background-masker main-image-seperator-2"></div>
                                    <div className="background-masker thumb-left-1"></div>
                                    <div className="background-masker thumb-left-2"></div>
                                    <div className="background-masker thumb-left-3"></div>
                                    <div className="background-masker thumb-left-4"></div>

                                    <div className="background-masker center-seperator-1"></div>
                                    <div className="background-masker center-top-1"></div>
                                    <div className="background-masker center-top-2"></div>
                                    <div className="background-masker center-top-3"></div>
                                    <div className="background-masker center-top-4"></div>
                                    <div className="background-masker center-seperator-2"></div>
                                    <div className="background-masker center-top-5"></div>
                                    <div className="background-masker center-seperator-3"></div>
                                    <div className="background-masker center-top-6"></div>
                                    <div className="background-masker center-top-7"></div>
                                    <div className="background-masker center-seperator-4"></div>

                                    <div className="background-masker right-seperator-1"></div>
                                    <div className="background-masker right-top-1"></div>
                                    <div className="background-masker right-top-2"></div>
                                    <div className="background-masker right-seperator-2"></div>
                                    <div className="background-masker right-top-3"></div>
                                    <div className="background-masker right-top-4"></div>
                                    <div className="background-masker right-seperator-3"></div>
                                    <div className="background-masker right-top-5"></div>
                                    <div className="background-masker right-top-6"></div>
                                    <div className="background-masker right-seperator-4"></div>
                                    <div className="background-masker right-top-7"></div>
                                    <div className="background-masker right-top-8"></div>
                                    <div className="background-masker right-seperator-5"></div>
                                    <div className="background-masker right-top-9"></div>
                                    <div className="background-masker right-top-10"></div>
                                    <div className="background-masker right-seperator-6"></div>
                                    <div className="background-masker right-top-11"></div>
                                    <div className="background-masker right-top-12"></div>
                                    <div className="background-masker right-seperator-7"></div>
                                    <div className="background-masker right-top-13"></div>
                                    <div className="background-masker right-top-14"></div>
                                    <div className="background-masker right-seperator-8"></div>
                                    <div className="background-masker right-top-15"></div>
                                    <div className="background-masker right-top-16"></div>
                                </div>
                            </div>
                        </div>

                        <div className="timeline-wrapper desktop-d-none">
                            <div className="timeline-item">
                                <div className="animated-background">
                                    <div className="background-masker center-seperator-1"></div>
                                    <div className="background-masker center-top-1"></div>
                                    <div className="background-masker center-top-2"></div>
                                    <div className="background-masker center-top-3"></div>
                                    <div className="background-masker center-top-4"></div>
                                    <div className="background-masker center-seperator-2"></div>
                                    <div className="background-masker center-top-5"></div>
                                    <div className="background-masker center-seperator-3"></div>
                                    <div className="background-masker center-top-6"></div>
                                    <div className="background-masker center-seperator-4"></div>

                                    <div className="background-masker main-image-seperator"></div>
                                    <div className="background-masker main-image-seperator-2"></div>
                                    <div className="background-masker thumb-left-1"></div>
                                    <div className="background-masker thumb-left-2"></div>
                                    <div className="background-masker thumb-left-3"></div>
                                    <div className="background-masker thumb-left-4"></div>

                                    <div className="background-masker right-seperator-1"></div>
                                    <div className="background-masker right-top-1"></div>
                                    <div className="background-masker right-seperator-2"></div>
                                    <div className="background-masker right-top-2"></div>
                                    <div className="background-masker right-seperator-3"></div>
                                    <div className="background-masker right-top-3"></div>
                                    <div className="background-masker right-seperator-4"></div>
                                    <div className="background-masker right-top-4"></div>
                                    <div className="background-masker right-top-5"></div>
                                    <div className="background-masker right-top-6"></div>
                                    <div className="background-masker right-seperator-5"></div>
                                </div>
                            </div>
                        </div>

                        <div className="timeline-wrapper-tabs">
                            <div className="timeline-item-tabs">
                                <div className="animated-background-tabs">
                                    <div className="background-masker-tabs bottom-seperator-1"></div>
                                    <div className="background-masker-tabs bottom-top-1"></div>
                                    <div className="background-masker-tabs bottom-top-2"></div>
                                    <div className="background-masker-tabs bottom-top-3"></div>

                                    <div className="background-masker-tabs bottom-seperator-2"></div>
                                    <div className="background-masker-tabs bottom-top-4"></div>
                                    <div className="background-masker-tabs bottom-top-5"></div>

                                    <div className="background-masker-tabs bottom-seperator-3"></div>
                                    <div className="background-masker-tabs bottom-top-6"></div>
                                    <div className="background-masker-tabs bottom-top-7"></div>
                                    <div className="background-masker-tabs bottom-top-8"></div>

                                    <div className="background-masker-tabs bottom-seperator-4"></div>
                                    <div className="background-masker-tabs bottom-top-9"></div>
                                    <div className="background-masker-tabs bottom-top-10"></div>

                                    <div className="background-masker-tabs bottom-seperator-5"></div>
                                    <div className="background-masker-tabs bottom-top-11"></div>
                                    <div className="background-masker-tabs bottom-top-12"></div>
                                    <div className="background-masker-tabs bottom-top-13"></div>

                                    <div className="background-masker-tabs bottom-seperator-6"></div>
                                    <div className="background-masker-tabs bottom-top-14"></div>
                                    <div className="background-masker-tabs bottom-top-15"></div>

                                    <div className="background-masker-tabs bottom-seperator-7"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            );
        }

        const productId = this.props.productState.value.id;

        const productContext: ProductContextModel = {
            product: this.props.productState.value,
            productInfo: this.props.productInfo,
            onQtyOrderedChanged: o => {
                this.props.changeQtyOrdered({
                    qtyOrdered: o,
                    productId,
                });
            },
            onUnitOfMeasureChanged: o => {
                this.props.changeUnitOfMeasure({
                    unitOfMeasure: o,
                    productId,
                });
            },
        };

        return (
            <Page data-test-selector={`productDetails_productId_${productId}`} className="mainProductDetails">
                {this.props.selectedProductId && (
                    <CurrentCategory>
                        <ProductContext.Provider value={productContext}>
                            <ParentProductIdContext.Provider value={this.props.parentProductState?.value?.id}>
                                <Zone contentId={this.props.id} zoneName="Content" />
                            </ParentProductIdContext.Provider>
                        </ProductContext.Provider>
                    </CurrentCategory>
                )}
                <Modals />
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withCallDeferredApi(ProductDetailsPage)),
    definition: {
        hasEditableUrlSegment: false,
        hasEditableTitle: false,
        supportsProductSelection: true,
        pageType: "System",
        fieldDefinitions: [HideHeader, HideFooter],
    },
};

export default pageModule;

export const ProductDetailsPageContext = "ProductDetailsPage";
